var React = require('react');
var ReactNative = require('react-native');

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpButton = require('./ReUpButton.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var NetworkManager = require('./NetworkManager');
var DatePicker = require('./wrappers/react-native-datepicker-wrapper');

var {
  View,
  StyleSheet,
  Platform,
} = ReactNative;

var Birthday = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      date : Platform.OS == 'web' ? new Date() : false,
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;
    setTimeout(()=>
    {
      if( typeof thisThing.refs.date !== 'undefined' ) thisThing.refs.date.onPressDate();
    }, 500)
  },

  didUpdate: function()
  {

  },

  setDate: function(date)
  {
    if( typeof date === 'undefined' ) date = this.state.date;
    var appManager = this.props.appManager;

    var thisThing = this;
    thisThing.setState({date})
  },

  setBirthday: function(birthday)
  {
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var bdayString = locManager.dateTimeReUp(birthday);

    appActions.setSpinnerShown(true);
    NetworkManager.updateUser(appManager, {DOB:bdayString},
    function(data)
    {
      if( typeof thisThing.props.extras.didSetBirthday !== 'undefined' ) thisThing.props.extras.didSetBirthday();
      appActions.setSpinnerShown(false);
      appActions.requestPop();
    },
    function(data)
    {
      appActions.setSpinnerShown(false);
    },
    function()
    {
      appActions.setSpinnerShown(false);
    })
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();
    if( user == null ) return null;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var selectBirthdayLocalized = locManager.localizedStringForKey("SELECT_BIRTHDAY_BUTTON");
    var setBirthdayLocalized = locManager.localizedStringForKey("SET_BIRTHDAY_BUTTON");

    return (
      <View style={styles.container}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} />}
        <View style={{position:'absolute', left:0, right:0, top:0, bottom:0, backgroundColor: generalColor}} />
        <ReUpScrollView ref="ptr" bounces={true} responder={this} isEmpty={false}>
          <View style={{flexDirection:'row', backgroundColor:instructionColor}}>
            <View style={{padding:10, flex:1}}>
              <ReUpText appManager={appManager} style={{color:instructionTitleColor}}>
                {this.props.featureData.instructions}
              </ReUpText>
            </View>
          </View>
          <ShadowView layout={this.state.layout} appManager={appManager}/>
          <View style={{alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
            <DatePicker
                ref="date"
                key="date"
                style={{width: 200, height:this.state.date !== false ? 60 : 0, justifyContent:'center', alignItems:'center', opacity:this.state.date !== false ? 1 : 0}}
                date={this.state.date}
                mode="date"
                format="MMMM DD, YYYY"
                confirmBtnText={locManager.localizedStringForKey("CONFIRM_BUTTON", "Confirm")}
                cancelBtnText={locManager.localizedStringForKey("CANCEL_BUTTON", "Cancel")}
                onDateChange={(dateStr, date) => {thisThing.setDate(date)}}
                customStyles={
                {
                  dateInput: {
                    borderColor:'transparent',
                  },
                  placeholderText: {

                  },
                  dateText: {
                    color:generalTitleColor, fontSize:22, fontWeight:'bold'
                  },
                }}
                showIcon={false}
                />
          </View>
          {
            this.state.date === false ?
              <ReUpButton onPress={()=>{this.refs.date.onPressDate()}} style={{marginTop:10, marginHorizontal:20}} appManager={appManager} text={selectBirthdayLocalized} />
            : 
              <ReUpButton onPress={()=>{this.setBirthday(this.state.date)}} style={{marginTop:10, marginHorizontal:20}} appManager={appManager} text={setBirthdayLocalized} />
          }
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
});

Birthday.dataDependencies = ["Users", "Campaigns"];

module.exports = Birthday;



// WEBPACK FOOTER //
// ./src/Birthday.js